import React, { useState, useEffect } from 'react'
import api from "../../utils/api";
import { toast } from "react-toastify";
import Modal, { defaultStyles } from "react-modal";
import ModalContent from "./../../common/Modal/ModalContent";
import close_modal from "./../../assets/ic_close_wh.svg";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
const ReactTableFixedColumns = withFixedColumns(ReactTable);


const AdminExpertSlots = () => {

    //Expert Calendar List

    const [ExpertPartner, setExpertPartner] = useState();
    const [day, setDay] = useState("")
    const [slot, setSlot] = useState("")
    const [deleteId, setDeleteId] = useState("")
    const [newSlotDay, setNewSlotDay] = useState("")
    const [newSlotTime, setNewSlotTime] = useState("")
    const [SelectedExpertId, setSelectedExpertId] = useState('')
    

    const [modalIsOpen, setModalIsOpen] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  const setModalIsOpenToTrue = () => {
    setModalIsOpen(true)
  }

  const setModalIsOpenToFalse = () => {
      setModalIsOpen(false)
      setNewSlotDay("")
      setNewSlotTime("")
  }

  const setModalOpenToTrue = () => {
    setModalOpen(true)
  }

  const setModalOpenToFalse = () => {
    setModalOpen(false)
  }
    
    const setDeleteModalisOpenIsTrue = () => {
        setIsOpen(true)
    }

    const setDeleteModalisOpenIsFalse = () => {
        setIsOpen(false)
    }
    
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
  
  const slotList = ['10:00-11:00 AM','11:00-12:00 PM','12:00-01:00 PM','01:00-02:00 PM','02:00-03:00 PM','03:00-04:00 PM','04:00-05:00 PM','05:00-06:00 PM']

    useEffect(() => {
        ExpertCalenderData();
        ExpertPartnerDropdownList()
      }, []);

    const ExpertCalenderData = () => {
        api.getAllExpertCalenderList().then(({ data }) => {
          console.log("Data", data);
          setExpertPartner(data);
        });
    };
    

    const [ltExpert, setLTExpert] = useState()
    
    const ExpertPartnerDropdownList = () => {
        api.allExpPartnerList().then(({ data }) => {
            setLTExpert(data)
        })
    }

    let Experts = []

    if (ltExpert) {
        // ltExpert.map((ele) => {
        //     Experts.push(ele.sName)
        // })
         Experts =
      ltExpert
        ?.map((ele) => ({
          id: ele.id,
          name: ele.sName,
        }))
        ?.sort((a, b) => a.name.localeCompare(b.name)) || [];
  
    }


    console.log("Hello==", Experts)
    
    const [SelectedExpert, setSelectedExpert] = useState('')

    console.log(SelectedExpert)

    let SlotsAvailable;
    const data = [
        {
            Day: "Monday",
            metadata: []
        },
        {
            Day: "Tuesday",
            metadata: []
        },
        {
            Day: "Wednesday",
            metadata: []
        },
        {
            Day: "Thursday",
            metadata: []
        },
        {
            Day: "Friday",
            metadata: []
        }
    ]

    let ExpertID

    if (ExpertPartner) {
        ExpertPartner.filter((ele) => ele.refExternalServicePartner === SelectedExpert ? SlotsAvailable = ele.calender_slots : "")
        ExpertPartner.filter((ele) => ele.refExternalServicePartner === SelectedExpert ? ExpertID = ele.refExternalServicePartner_id : "")
    }

    if (SlotsAvailable) {
        SlotsAvailable.filter((ele) => 
            ele.day === "Monday" ? data[0]["metadata"].push(ele) : ele.day === "Tuesday" ? data[1]["metadata"].push(ele) :ele.day === "Wednesday" ? data[2]["metadata"].push(ele) :ele.day === "Thursday" ? data[3]["metadata"].push(ele) :ele.day === "Friday" ? data[4]["metadata"].push(ele) : ""
        )
    }
    

    console.log("data==", data)
    
    // const getSlotData = (day, time) =>  {
    //     setDay(day)
    //     setSlot(time)
    // }

    console.log("new", day, slot)
    // const data = [
    //     {
    //         Day: "Monday",
    //         metadata: [{
    //             day: "Monday",
    //             time: "10:00-11:00 AM"
    //         },
    //         {
    //             day: "Monday",
    //             time: "11:00-12:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Tuesday",
    //         metadata: [{
    //             day: "Tuesday",
    //             time: "10:00-11:00 AM"
    //         },
    //         {
    //             day: "Tuesday",
    //             time: "01:00-02:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Wednesday",
    //         metadata: [{
    //             day: "Wednesday",
    //             time: "10:00-11:00 AM"
    //         },
    //         {
    //             day: "Wednesday",
    //             time: "01:00-02:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Thursday",
    //         metadata: [{
    //             day: "Thursday",
    //             time: "01:00-02:00 PM"
    //         },
    //         {
    //             day: "Thursday",
    //             time: "05:00-06:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Friday",
    //         metadata: [{
    //             day: "Friday",
    //             time: "11:00-12:00 PM"
    //         },
    //         {
    //             day: "Friday",
    //             time: "03:00-04:00 PM"
    //         }
    //     ]
    //     }
    // ]

    console.log("nsond", SlotsAvailable)

    let slotDeleteId 

    const getRowData = (e) => {
        console.log(e, e.value)
        e.original.metadata.filter((ele) => ele.time === e.column.Header ?  setDeleteId(ele.id) : "")
    }
  
  const addSlotData = (e) => {
    setModalOpenToTrue()
    setNewSlotDay(e.original.Day)
    setNewSlotTime(e.column.Header)
  }


    const deleteSlot = () => {
        let payload = {
            id: deleteId
        }

      api.deleteExpertSlots(payload).then(({ data }) => {
        console.log("0000000000000000000",data)
        if (data[0] === 'deleted') {
          toast("Calendar Slot Deleted Successfully.", {
            type: toast.TYPE.SUCCESS,
            autoClose: 5000
          })
          setTimeout(() => {
            setModalIsOpenToFalse()
            ExpertCalenderData()
            setDeleteModalisOpenIsFalse()
          },2000)
        } else if (data[0] === 'Not Deleted') {
          toast("Cannot Delete Slot. Appointment Exists.", {
            type: toast.TYPE.ERROR,
            autoClose: 5000
          })
        } else {
          toast("Something Went Wrong", {
            type: toast.TYPE.ERROR,
            autoClose: 5000
          })
        }
      })
      
    }
  

    // useEffect(() => {
    //     deleteSlot()
    // }, [deleteId])
    
        console.log("DeleteID == ",deleteId)


    const columns = [
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "Day",
              accessor: "Day",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "10:00-11:00 AM",
              accessor: "Day",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
            Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "10:00-11:00 AM")

                return (
                <>
                    {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "10:00-11:00 AM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "11:00-12:00 PM",
              accessor: "Day",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
              Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "11:00-12:00 PM")
                return (
                <>
                    {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "11:00-12:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "12:00-01:00 PM",
            //   accessor: "refExternalServicePartner",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
              Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "12:00-01:00 PM")
                return (
                <>
                        {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "12:00-01:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "01:00-02:00 PM",
            //   accessor: "refExternalServicePartner",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
              Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "01:00-02:00 PM")
                return (
                <>
                        {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "01:00-02:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "02:00-03:00 PM",
            //   accessor: "refExternalServicePartner",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
              Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "02:00-03:00 PM")
                return (
                <>
                        {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "02:00-03:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "03:00-04:00 PM",
            //   accessor: "refExternalServicePartner",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
              Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "03:00-04:00 PM")
                return (
                <>
                        {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "03:00-04:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
              Header: "04:00-05:00 PM",
            //   accessor: "refExternalServicePartner",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
              Cell: (row) => {
                // console.log("Original", original)
                let m=row.original.metadata.filter(ele=>ele.time === "04:00-05:00 PM")
                return (
                <>
                        {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "04:00-05:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
        {
            headerStyle: {
                whiteSpace: "unset",
                borderBottom: "solid 1px #ccc",
                textAlign: "center",
              },
            Header: "05:00-06:00 PM",
            //   accessor: "refExternalServicePartner",
              style: { whiteSpace: "unset", textAlign: "center" },
              // width: 100,
          Cell: (row, original) => {
            let m=row.original.metadata.filter(ele=>ele.time === "05:00-06:00 PM")
                return (
                  <>
                    {
                      m.length > 0 ?
                            m.map((ele) => ele.time === "05:00-06:00 PM" ? <button onClick={() => getRowData(row) } style={{
                                background: "green",
                                width: "100%",
                                height: "100%"
                            }}><img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={() => setDeleteModalisOpenIsTrue()}
                              /></button>
                              :
                              ""
                        ) :
                        <h1 style={{
                          width: "100%",
                          height: "100%"
                    }} onClick={() => addSlotData(row)}></h1>
                    }
                    
                    </>
                )
              }
        },
    ]

    // const data = [
    //     {
    //         Day: "Monday",
    //         metadata: [{
    //             day: "Monday",
    //             time: "10:00-11:00 AM"
    //         },
    //         {
    //             day: "Monday",
    //             time: "11:00-12:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Tuesday",
    //         metadata: [{
    //             day: "Tuesday",
    //             time: "10:00-11:00 AM"
    //         },
    //         {
    //             day: "Tuesday",
    //             time: "01:00-02:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Wednesday",
    //         metadata: [{
    //             day: "Wednesday",
    //             time: "10:00-11:00 AM"
    //         },
    //         {
    //             day: "Wednesday",
    //             time: "01:00-02:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Thursday",
    //         metadata: [{
    //             day: "Thursday",
    //             time: "01:00-02:00 PM"
    //         },
    //         {
    //             day: "Thursday",
    //             time: "05:00-06:00 PM"
    //         }
    //     ]
    //     },
    //     {
    //         Day: "Friday",
    //         metadata: [{
    //             day: "Friday",
    //             time: "11:00-12:00 PM"
    //         },
    //         {
    //             day: "Friday",
    //             time: "03:00-04:00 PM"
    //         }
    //     ]
    //     }
    // ]

    const AddTimeslot = () => {
        // if (!newSlotDay) {
        //   toast("Please Select New Slot Day", {
        //     type: toast.TYPE.ERROR,
        //   })
        // } else if (!newSlotTime) {
        //   toast("Please Select New Slot Time", {
        //     type: toast.TYPE.ERROR,
        //   })
        // } else {
          let payload = {
            // refExternalServicePartner: ExpertID,
            refExternalServicePartner: ExpertID ? ExpertID : SelectedExpertId,
            day: newSlotDay,
            time: newSlotTime
          }
    
          api.addExpertSlots(payload).then(({ data }) => {
            if (data.message === "Expert Calendar Slot Added Successfully.") {
              toast("Expert Slot Updated Successfully", {
                type: toast.TYPE.SUCCESS,
                autoClose: 5000
              })
              setTimeout(() => {
                setModalOpenToFalse()
                ExpertCalenderData()
              },2000)
            } else {
              toast(data.message, {
                type: toast.TYPE.ERROR,
                autoClose: 5000
              })
            }
          })
          
        // }
      }
    

    return (
        <div>
            <div>                
                <select
                    style={{
                        width: "18%",
                        height: '50px',
                        marginLeft: '42%',
                    marginTop: "10px"
                    }}
                    // onChange={({ target }) => {
                    //     const {value} = target
                    //     setSelectedExpert(value)
                    // }}
                    onChange={(e) => {
                      const selected = Experts.find(
                        (ele) => ele.id.toString() === e.target.value
                      )
                      setSelectedExpert(selected?.name)
                      setSelectedExpertId(selected?.id)
                    }}
                >
                <option value="" selected disabled hidden>Select Expert Partner</option>
                {
                    Experts.map((ele, id) => {
                        return <option key={id} value={ele.id}>
                            {ele?.name}
                        </option>
                    })
                }
            </select>
            </div>
            

            <div className='expert_name' style={{
                margin: "50px"
            }}>
                <span className='spled-colored-label'>EXPERT NAME :</span>
                <span>{SelectedExpert ? <span style={{
                    padding: '10px',
                }} className='spled-black-text'>{ SelectedExpert }</span> : "NA" }</span>
            </div>

            <div>
                {
                    SlotsAvailable ?
                      
                <ReactTableFixedColumns
                  // onClick={console.log("hsjk")}
                    minRows={0}
                    data={data}
                        columns={columns}
                        showPagination={false}
                    style={{ overflowY: "initial", height: "390px" }}
                    className="-striped hide-scrollbar overflowcss"
                    
                            />
                            
                            : 

              SelectedExpert ?

                <ReactTableFixedColumns
                  // onClick={console.log("hsjk")}
                  minRows={0}
                  data={data}
                  columns={columns}
                  showPagination={false}
                  style={{ overflowY: "initial", height: "390px" }}
                  className="-striped hide-scrollbar overflowcss"
                />
                :
                ""
        
                }
                
            {/* <ReactTableFixedColumns
                minRows={0}
                data={data}
                    columns={columns}
                    showPagination={false}
                style={{ overflowY: "initial", height: "390px" }}
                className="-striped hide-scrollbar overflowcss"
            /> */}
                <Modal isOpen={modalIsOpen}>
        <ModalContent className="general-modal">
          <div className="modal-header">
            <span className="modal-title">Add Expert Slot</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={setModalIsOpenToFalse}
            />
          </div>
          <div className="modal-body">
            <div className="expert-details">
              <span className="spled-colored-label" style={{ padding: '15px' }}>
                Expert Name :
              </span>
              <span className="spled-info-title">
                {SelectedExpert}
              </span>

              <div>
                <span className="spled-colored-label" style={{ padding: '15px' }}> Expert ID: </span> <span className="spled-black-text">{ExpertID}</span>
              </div>

              <div className="row">
                <div className="col-6">
                <label className="my-services-model-value" style={{
                                                marginTop: '25px',
                                                textAlign: 'center'
                  }}>Select Day of New Slot: </label>
                  <select
                    style={{
                      width: "65%",
                      height: '40px',
                      padding: '5px'
                  }}
                    onChange={({ target }) => {
                        setNewSlotDay(target.value)
                      }}
                    value={newSlotDay ? newSlotDay : "newDay"}
                  >
                    <option value="newDay" selected disabled>Select an Option</option>
                  {
                    days.map((ele) => {
                      return <option>{ele}</option>
                    })
                  }
                </select>
                </div>

                <div className="col-6">
                <label className="my-services-model-value" style={{
                                                marginTop: '25px',
                                                textAlign: 'center'
                  }}>Select Time of New Slot: </label>

                <select
                    style={{
                      width: "65%",
                      height: '40px',
                      padding: '5px'
                  }}
                    onChange={({ target }) => {
                      setNewSlotTime(target.value)
                    }}
                    value={newSlotTime ? newSlotTime : "newTimeSlot"}
                  >
                    <option value="newTimeSlot" selected disabled>Select an Option</option>
                  {
                    slotList.map((ele) => {
                      return <option>{ele}</option>
                    })
                  }
                </select>

                </div>
              </div>
              <div style={{
                                    margin: '20px',
                                    textAlign: 'center'
                                }}>
                  {/* <Button className="text-center"
                    // onClick={() => {

                    //                     bookExpert()
                    // }}
                  >Book Appointment</Button> */}
                <button className="my-services-model-submit-btn"
                onClick={AddTimeslot}>
                  Add Slot
                </button>
                                </div>
                
                
            </div>
          </div>
        </ModalContent>
                </Modal>
                

                <Modal
        isOpen={isOpen}
        >
        <ModalContent className="confirmation">
        <div className="modal-header">
            <span className="modal-title">Confirm Delete Expert Slot</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={setDeleteModalisOpenIsFalse}
            />
          </div>
          <div className="modal-body">
            Are you sure you want to perform this action?
          </div>
          <div className="modal-footer mt10">
            <button className='my-services-model-submit-btn' onClick={() => deleteSlot()}>Yes</button>
            <button onClick={setDeleteModalisOpenIsFalse} className='my-services-model-cancel-btn'>No</button>
          </div>
        </ModalContent>
          </Modal>
          

          <Modal
        isOpen={modalOpen}
        >
        <ModalContent className="confirmation">
        <div className="modal-header">
            <span className="modal-title">Confirm Add Expert Slot</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={setModalOpenToFalse}
            />
          </div>
          <div className="modal-body">
            Are you sure you want to perform this action?
          </div>
          <div className="modal-footer mt10">
            <button className='my-services-model-submit-btn' onClick={() => AddTimeslot()}>Yes</button>
            <button onClick={setModalOpenToFalse} className='my-services-model-cancel-btn'>No</button>
          </div>
        </ModalContent>
      </Modal>
      
            </div>

        </div>
    )
}

export default AdminExpertSlots
